// src/components/QNoms.jsx
import React, { useEffect, useState } from 'react';
import { FaPlus, FaTrashAlt } from 'react-icons/fa';
import {
  fetchQnoms,
  createQnom,
  deleteQnom
} from '../../data/fetchData';


const QNoms = () => {
  const [loading, setLoading] = useState(true);
  const [qnoms, setQnoms] = useState([]);
  const [newQnom, setNewQnom] = useState('');

  useEffect(() => {
    fetchQnoms()
      .then(list => setQnoms(list))
      .catch(err => console.error('Error fetching Qnoms:', err))
      .finally(() => setLoading(false));
  }, []);

  const handleAdd = () => {
    // Valideerime, et väärtus ei ole tühi
    if (!newQnom || newQnom.trim() === '') {
      return;
    }
    
    createQnom(newQnom.trim())
      .then(created => {
        setQnoms(prev => [...prev, created]);
        setNewQnom('');
      })
      .catch(err => console.error('Error creating QNom:', err));
  };

  const handleDelete = id => {
    deleteQnom(id)
      .then(() => {
        setQnoms(prev => prev.filter(q => q.id !== id));
      })
      .catch(err => console.error('Error deleting QNom:', err));
  };

  if (loading) return <p>Loading…</p>;

  return (
    <div className="p-4">
      <div className="flex mb-4">
        <input
          type="text"
          value={newQnom}
          onChange={e => setNewQnom(e.target.value)}
          placeholder="Lisa uus Qn/m³"
          className="flex-grow p-2 border border-gray-300 rounded-md mr-2"
        />
        <button
          onClick={handleAdd}
          className="p-2 bg-primary text-white rounded-md hover:bg-primary-hover"
        >
          <FaPlus />
        </button>
      </div>

      <ul className="space-y-2">
        {qnoms.map(q => (
          <li
            key={q.id}
            className="flex justify-between items-center p-2 border border-gray-300 rounded-md"
          >
            <span className="truncate w-3/4">{q.q_nom}</span>
            <button
              onClick={() => handleDelete(q.id)}
              className="text-red-500 hover:text-red-700"
            >
              <FaTrashAlt />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default QNoms;
